// The existing CUSTOM_CONFIGURED target basis. No independent rupee setting.
export function targetRupees(allocated, percent) {
  if (percent === "" || percent == null || !Number.isFinite(Number(allocated)) || !(Number(allocated) > 0)) return "";
  const value = Number(allocated) * Number(percent) / 100;
  return Number.isFinite(value) && value >= 0 ? value.toFixed(2) : "";
}

export function targetPercent(allocated, rupees) {
  if (rupees === "" || rupees == null || !Number.isFinite(Number(allocated)) || !(Number(allocated) > 0)) return "";
  const value = Number(rupees) * 100 / Number(allocated);
  return Number.isFinite(value) && value >= 0 ? String(value) : "";
}
